let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kSQJv")).then(() => parcelRequire('l58Lh'));